import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';
import {
  STATE_CHAOS_LEVELS,
  CORRUPTIONS,
  DOMESTIC_POLICIES,
  FOREIGN_POLICIES
} from '../../../constants/state-config.constants';

interface StateEntry {
  azgaarId?: number;
  name: string;
  corruption: string;
  domesticPolicy: string;
  foreignPolicy: string;
  notes: string;
}

@Component({
    selector: 'app-states-step',
    templateUrl: './states-step.component.html',
    styleUrls: ['./states-step.component.scss'],
    standalone: false
})
export class StatesStepComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  chaosLevels = STATE_CHAOS_LEVELS;
  corruptions = CORRUPTIONS;
  domesticPolicies = DOMESTIC_POLICIES;
  foreignPolicies = FOREIGN_POLICIES;

  mapName = '';
  stateChaosLevel = '';
  statesList: StateEntry[] = [];

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';
      this.stateChaosLevel = state.stateChaosLevel || '';

      // Initialize states from state, mapping prefilled data
      if (state.states && state.states.length > 0) {
        this.statesList = state.states.map((s: any) => ({
          azgaarId: s.azgaarId || s.azgaar_id,
          name: s.name,
          corruption: s.corruption || '',
          domesticPolicy: s.domesticPolicy || '',
          foreignPolicy: s.foreignPolicy || '',
          notes: s.notes || ''
        }));
      } else {
        let extractedStates: StateEntry[] = [];
        if (state.mapJson) {
          const json = state.mapJson;
          const rawStates = json.states || json.pack?.states || [];
          extractedStates = rawStates
            .filter((s: any) => s && s.name && s.name !== 'Neutral' && s.name.toLowerCase() !== 'none' && s.name !== 'Wild')
            .map((s: any) => ({
              azgaarId: s.i,
              name: s.name,
              corruption: '',
              domesticPolicy: '',
              foreignPolicy: '',
              notes: ''
            }));
        }

        if (extractedStates.length > 0) {
          this.statesList = extractedStates;
        } else {
          this.statesList = [
            { azgaarId: 1, name: 'State1', corruption: '', domesticPolicy: '', foreignPolicy: '', notes: '' },
            { azgaarId: 2, name: 'State2', corruption: '', domesticPolicy: '', foreignPolicy: '', notes: '' },
            { azgaarId: 3, name: 'State3', corruption: '', domesticPolicy: '', foreignPolicy: '', notes: '' }
          ];
        }
      }
      this.cdr.detectChanges();
    });
  }

  saveState(): void {
    this.stateService.updateState({
      stateChaosLevel: this.stateChaosLevel,
      states: this.statesList
    });
  }

  onNext(): void {
    this.saveState();
    this.next.emit();
  }

  onBack(): void {
    this.saveState();
    this.back.emit();
  }
}
